import dynamic from 'next/dynamic'

import { Button, SafeHtml } from '@thg-commerce/gravity-elements'
import { mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'

const Tick = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/Tick'),
)

export const Container = styled.div`
  text-align: center;
  padding: ${spacing(5)} 0;

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    padding: ${spacing(6)} 0;
  }
`

export const StyledWrapper = styled.div`
  width: 340px;
  margin: 0 auto;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    width: 420px;
  }
`

export const MainTitle = styled.h2`
  ${Text('xlarge1', 'alternate')};
  margin-bottom: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-bottom: ${spacing(4)};
  }
`

export const MainSubtitle = styled(SafeHtml)`
  ${Text('large1', 'alternate')};
  margin-bottom: ${spacing(2)};
`
export const SecondarySubtitle = styled(SafeHtml)`
  ${Text('bodyText', 'default')};
`

export const ReferralContainer = styled.div`
  border: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  padding: ${spacing(2)};

  margin: ${spacing(4)} auto;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(3)};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin: ${spacing(4)} auto ${spacing(5)};
  }
`

export const ReferralsTitle = styled.p`
  ${Text('medium1', 'alternate')};
  margin-bottom: ${spacing(2)};
`

export const ReferralsItemsContainer = styled.div`
  display: flex;
  flex-direction: row;
`

export const ReferralsItem = styled.div`
  width: 50%;
  &:first-child {
    border-right: 1px solid ${(props) => props.theme.colors.palette.greys.light};
  }
`

export const ReferralsItemTitle = styled.p`
  ${Text('bodyText', 'default')};
  margin-bottom: ${spacing(1)};
`

export const ReferralsItemValue = styled.p`
  ${Text('medium1', 'alternate')};
`

export const ReferralsTermsText = styled.p`
  ${Text('small', 'default')};
  margin-top: ${spacing(2)};
`

export const ShareTitle = styled.p`
  ${Text('large1', 'alternate')};
  margin-bottom: ${spacing(4)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    margin-bottom: ${spacing(3)};
  }
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.palette.greys.white};
`

export const StyledInput = styled.input`
  ${Text('bodyText', 'default')};
  height: 48px;
  width: 100%;
  padding: ${spacing(1)} ${spacing(1.25)} ${spacing(1)} ${spacing(2)};
  border-width: ${(props) =>
    props.theme.formgroup.general.border.default.width};
  border-color: ${(props) => props.theme.colors.palette.greys.light};
  border-style: ${(props) =>
    props.theme.formgroup.general.border.default.style};
  border-right: none;

  &:focus {
    border-width: ${(props) =>
      props.theme.formgroup.general.border.focus.width};
    border-color: ${(props) =>
      props.theme.formgroup.general.border.focus.color};
    border-style: ${(props) =>
      props.theme.formgroup.general.border.focus.style};
    border-right: none;
  }

  &:focus-visible {
    outline: none;
  }
`

export const StyledCopyToClipboardIcon = styled(Button)`
  button {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const StyledSeparator = styled.div`
  margin: ${spacing(4)} 0;
  position: relative;
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};
`

export const StyledSeparatorText = styled.span`
  ${Text('bodyText', 'default')};
  padding: 0 ${spacing(1)};
  background: ${(props) => props.theme.colors.palette.greys.white};
  position: absolute;
  transform: translate(-50%, 0px);
  bottom: -${spacing(1.5)};
  text-transform: uppercase;
`

export const CodeTitle = styled.p`
  ${Text('bodyText', 'alternate')};
`

export const StyledCode = styled.div`
  display: inline-block;
  margin-top: ${spacing(2)};
  padding: ${spacing(1.5)} ${spacing(6.5)};
  background: ${(props) => props.theme.colors.palette.greys.light};
`

export const StyledReferralIconLi = styled.li`
  display: inline-block;
  margin-right: ${spacing(2)};
  margin-top: 0;

  &:last-child {
    margin-right: 0;
  }
`

export const StyledReferralIconLink = styled.a`
  transition: 0.36s ease;
  cursor: pointer;
  display: block;
  line-height: initial;

  &:hover {
    opacity: 0.8;
  }
`

export const FormContainer = styled.div`
  display: flex;
  flex: 1;
  margin: ${spacing(3)};
  flex-direction: column;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    overflow: auto;
    margin: ${spacing(2)} ${spacing(4)} ${spacing(3)};
  }
`

export const ModalTitle = styled.p`
  ${Text('medium1', 'alternate')};
  margin-bottom: ${spacing(2)};
`

export const FormWrapper = styled.div`
  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    max-height: 185px;
  }
`
export const MessageContainer = styled.div`
  margin: auto;
  padding-top: ${spacing(3)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding-top: 0;
  }
`

export const SubmitButton = styled(Button)`
  width: 100%;
  margin-top: ${spacing(2)};
`

export const SuccessTick = styled(Tick)`
  width: 35px;
  height: 35px;
  stroke: ${(props) => props.theme.colors.palette.brand.base};
  display: block;
  margin: auto;
`

export const SubmittedTitle = styled.p`
  ${Text('medium1', 'alternate')};
  text-align: center;
  margin-top: ${spacing(4)};
`
